import React from 'react'
import { ORGANIZATION_STATUSES, TRANSLATED_PACKAGE_STATUSES, USER_STATUSES } from "../../../../config/constants";
import { displayUsername } from "../../../../helpers/displayUsername";
import moment from 'moment';
import { ViewPackage } from './actionButtons/ViewPackage';
import { ChangeOwner } from './actionButtons/ChangeOwner';
import { ChangePackageGroup } from './actionButtons/ChangePackageGroup';
import { ROUTE_PACKAGE_VIEW, ROUTE_CLIENT_USER_VIEW, ROUTE_CLIENT_ORGANIZATIONS_VIEW } from '../../../../config/routes';
import { LinkResource } from '../../../../components/shared/LinkResource';
import { FormattedMessage } from 'react-intl';

const TableRow = (props) => {
  const { actionCallback, item, index } = props;

  return (
    item ?
      <>
        <tr>
          <td> 
            {
              <LinkResource
                displayText={item.id}
                resourceLink={ROUTE_PACKAGE_VIEW}
                resourceParamId={{':packageId': item.uuid}}
              />
            }
            </td>
          <td>{moment(item.created_at).format('lll')}</td>
          <td className="documents-table__document-name-td">
            <div className="documents-table__scroll-cell">
              {item.name}
            </div>
          </td>
          <td>
            {
              item.user?.id && item.user?.status === USER_STATUSES.ACTIVE ? 
              <LinkResource
                displayText={displayUsername(item.user)}
                resourceLink={ROUTE_CLIENT_USER_VIEW}
                resourceParamId={{':userId': item.user.id}}
              /> :
              <FormattedMessage id="components.pages.organizations.table.tableRow.user_deleted" />
            }
          </td>
          <td className="documents-table__package-group-td">
            <div className="documents-table__scroll-cell">
              {item.package_group.name}
            </div>
          </td>
          <td>
            {
              item.organization?.id && item.organization?.status === ORGANIZATION_STATUSES.CREATED ?
              <LinkResource
                displayText={item.organization.name}
                resourceLink={ROUTE_CLIENT_ORGANIZATIONS_VIEW}
                resourceParamId={{':organizationId': item.organization.id}} 
              /> :
              <FormattedMessage id="components.pages.organizations.table.tableRow.organization_deleted" />
            }
          </td>
          <td>{TRANSLATED_PACKAGE_STATUSES[item.status]} {` (${item.status})`}</td>
          <td>
            <ChangeOwner
              actionCallback={actionCallback}
              packageDetails={item}
            />
            <ChangePackageGroup
              actionCallback={actionCallback}
              packageDetails={item}
            />
            <ViewPackage
              index={index}
              packageDetails={item}
            />
          </td>
        </tr>
      </>
      : null
  )
}

export { TableRow }
